import * as React from "react";
import { forwardRef } from "react";
const SvgClose = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { x: 3.41418, y: 2, width: 17.4333, height: 2, rx: 1, transform: "rotate(45 3.41418 2)", fill: "currentColor" }), /* @__PURE__ */ React.createElement("rect", { x: 2.1814, y: 14.3273, width: 17.4333, height: 2, rx: 1, transform: "rotate(-45 2.1814 14.3273)", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgClose);
export default ForwardRef;
